import { v4 as uuid } from 'uuid';

import { MemberInterface } from '@/types/Member';

import { Gender } from '@/enums/Gender';

import { TicketCategory } from '@/util/TicketCategory';
import { User } from '@/util/User';
import { DiscountCheckInterface } from '@/types/DiscountCheck';

export class Member extends User implements MemberInterface {
  id!: string;
  gender?: Gender;
  email?: string;
  firstname?: string;
  lastname?: string;
  dob?: Date | string;
  ticketCategoryId?: number;
  company?: string;
  city?: string;
  country?: string;
  street?: string;
  zip?: string;
  targetGroup?: string;
  community?: string;
  discount?: DiscountCheckInterface;
  discountCode?: string;
  apprentice?: string;
  apprenticeFirstname?: string;
  apprenticeLastname?: string;
  apprenticeEmail?: string;
  trainerFirstname?: string;
  trainerLastname?: string;
  trainerEmail?: string;

  constructor({
    id,
    gender,
    email,
    firstname,
    lastname,
    dob,
    company,
    city,
    country,
    street,
    zip,
    ticketCategoryId,
    targetGroup,
    community,
    discountCode,
    discount,
    apprentice,
    apprenticeFirstname,
    apprenticeLastname,
    apprenticeEmail,
    trainerFirstname,
    trainerLastname,
    trainerEmail
  }: MemberInterface) {
    super({
      id,
      gender,
      email,
      firstname,
      lastname,
      dob,
      company,
      city,
      country,
      street,
      zip,
      targetGroup,
      community,
      apprentice,
      apprenticeFirstname,
      apprenticeLastname,
      apprenticeEmail,
      trainerFirstname,
      trainerLastname,
      trainerEmail
    });
    this.ticketCategoryId = ticketCategoryId;
    this.discount = discount;
    this.discountCode = discountCode;
    this.apprentice = apprentice;
    this.apprenticeFirstname = apprenticeFirstname;
    this.apprenticeLastname = apprenticeLastname;
    this.apprenticeEmail = apprenticeEmail;
    this.apprenticeFirstname = trainerFirstname;
    this.apprenticeLastname = trainerLastname;
    this.apprenticeEmail = trainerEmail;
  }

  static create(ticketCategory: TicketCategory): Member {
    return new this({
      id: uuid(),
      ticketCategoryId: ticketCategory.entityId,
      gender: Gender.FEMALE
    });
  }
}
